if (!customElements.get('product-info')) {
  customElements.define('product-info', class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.quantity__input');
      this.currentVariant = this.querySelector('.product-variant-id');
      this.submitButton = this.querySelector('[type="submit"]');
      this.onVariantChange = this.onVariantChange.bind(this);
    }

    connectedCallback() {
      this.initializeProductSwapUtility();
      this.addEventListener('change', this.onVariantChange);
    }

    initializeProductSwapUtility() {
      this.preProcessHtmlCallbacks = [];
      this.postProcessHtmlCallbacks = [];
    }

    onVariantChange(e) {
      // Don't process if the change came from the hidden input itself
      if (e.target && e.target.name === 'id') {
        return;
      }

      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }

    updateOptions() {
      this.options = [];
      
      // Get all fieldsets (product options) in order they appear in DOM
      const fieldsets = Array.from(this.querySelectorAll('fieldset.product-form__input'));
      
      fieldsets.forEach(fieldset => {
        const legend = fieldset.querySelector('legend');
        const optionName = legend ? legend.textContent.trim() : '';
        
        // Find checked radio for this option
        const checkedRadio = fieldset.querySelector('input[type="radio"]:checked');
        
        if (checkedRadio) {
          this.options.push(checkedRadio.value);
        } else {
          // Fallback: get first radio's value if none checked
          const firstRadio = fieldset.querySelector('input[type="radio"]');
          if (firstRadio) {
            this.options.push(firstRadio.value);
          }
        }
      });
      
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const mediaGallery = this.querySelector('media-gallery');
      if (!mediaGallery) return;

      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      if (!form) return;

      const input = form.querySelector('input[name="id"]');
      if (input && this.currentVariant) {
        // Only update if the value is different to prevent infinite loops
        if (input.value !== this.currentVariant.id.toString()) {
          input.value = this.currentVariant.id;
        }
      }
    }

    updateVariantStatuses() {
      const addButtonText = this.querySelector('[data-add-button-text]');
      const pricePerItem = this.querySelector('.price-per-item');

      if (!this.currentVariant) return;

      if (pricePerItem) pricePerItem.classList.toggle('visibility-hidden', this.currentVariant.unit_price_measurement === undefined);

      if (addButtonText) {
        if (this.currentVariant.available) {
          addButtonText.textContent = window.variantStrings.addToCart;
        } else {
          addButtonText.textContent = window.variantStrings.soldOut;
        }
      }
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('.shopify-section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
      const requestedVariantId = this.currentVariant.id;
      const sectionId = this.dataset.originalSection || this.dataset.section;

      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(`price-${this.dataset.originalSection || this.dataset.section}`);

          const skuSource = html.getElementById(`Sku-${this.dataset.originalSection || this.dataset.section}`);
          const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection || this.dataset.section}`);
          const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

          if (source && destination) destination.innerHTML = source.innerHTML;
          if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
          }

          const price = document.getElementById(`price-${this.dataset.section}`);

          if (price) price.classList.remove('visibility-hidden');

          if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource && inventorySource.innerText === '');

          // Use the currentVariant availability instead of trying to parse the response
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

          publish(PUB_SUB_EVENTS.variantChange, {data: {
            sectionId,
            html,
            variant: this.currentVariant
          }});
        })
        .catch((error) => {
          this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
        });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    }

    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  });
}